function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-objetFlottant");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-objetFlottant",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,18.4666667 C7,15.8222222 11,15.8222222 15,18.4666667 L15,18.4666667 L15.2857143,18.6510582 C19.1904762,21.109612 23.0952381,21.0481481 27,18.4666667 L27,18.4666667 L27,27 L3,27 Z M9.75735931,5.4267859 L22.3143951,8.79143349 L19.4926621,19.3248259 C18.0903462,19.0919204 16.6880302,18.5339979 15.2857143,17.6510582 L15,17.4666667 C12.3349983,15.7048045 9.66999667,15.1167837 7.004995,15.7026043 L9.75735931,5.4267859 Z",
  id: "Combined-Shape"
})));

const SvgIco30ObjetFlottant = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ObjetFlottant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-objetFlottant.84f4d2db.svg";
export { ForwardRef as ReactComponent };